import LabelVue from '@/views/sm/label/label.vue';

const basePath = '/sm/label';
const role = 'sm'; // 角色身份

export const SM_LABEL_INDEX = 'sm-label-index';
export const SM_LABEL_CREATE = 'sm-label-create';
export const SM_LABEL_EDIT = 'sm-label-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: LabelVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_LABEL_INDEX,
      component: () => import(
        /* webpackChunkName: "label" */
        `@/views/${role}/label/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/create`,
      name: SM_LABEL_CREATE,
      component: () => import(
        /* webpackChunkName: "label-create" */
        `@/views/${role}/label/create.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SM_LABEL_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "label-edit" */
        `@/views/${role}/label/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
